import { ImageType, Maybe } from '@app/data'

export type ImageSize = Exclude<keyof ImageType, '__typename'>

export const getImageUrlFromImageType = (
  imageUrl: Maybe<ImageType> | undefined,
  size: ImageSize = 'medium'
): string => {
  if (!imageUrl) {
    return ''
  }

  let finalImageUrl: Maybe<string> | undefined

  switch (size) {
    case 'large':
      finalImageUrl = imageUrl.large || imageUrl.medium
      break

    case 'medium':
      finalImageUrl = imageUrl.medium || imageUrl.large
      break

    case 'small':
      finalImageUrl = imageUrl.small || imageUrl.medium
      break

    case 'thumbnail':
      finalImageUrl = imageUrl.thumbnail || imageUrl.small
      break

    default:
      finalImageUrl = imageUrl.medium
  }

  return finalImageUrl || imageUrl.default
}
